import React from 'react';

import InfoCard from './infoCard.js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { autoPlay } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const VIEW_INTERVAL = 10000;

export default function AnnouncementsCard(props) {
    const { headline } = props;
    return (
        <InfoCard
            className='announcements'
            title={
                <>
                    <FontAwesomeIcon 
                        size='lg' 
                        icon={['fas', 'bullhorn']} 
                        color='#FF7F2C' 
                        style={{ marginRight: 7 }}
                    />
                    ANNOUNCEMENT
                </>
            }
            titleStyle={{ backgroundColor: '#FCF8F3', color: '#2C266E' }}
            contentStyle={{ backgroundColor: '#FCF8F3', color: '#2C266E', marginTop: -15 }}
            content={<Headline data={headline} />}
        />
    );
};

const Headline = props => {
    let headline = props.data;
    let innerElement = () =>{
       return(
          <div>
             {headline.text}
             {headline.source && <div>-{headline.source}</div>}
          </div>
       )
    };
    if(headline.link) {
       return(
          <a href={headline.link}>
             {innerElement()}
          </a>
       )
    }
    return(
       <div>
          {innerElement()}
       </div>
    )
}